import type { PropsWithChildren } from "react";
import { Breadcrumb } from "../breadcrumb";
import { Menu } from "../menu";

export const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex h-screen bg-gray-100">
      {/* 側邊欄 */}
      <div className="w-64 h-full flex-shrink-0 shadow-lg">
        <Menu />
      </div>
      
      {/* 主要內容區 */}
      <div className="flex-grow overflow-auto">
        <div className="p-6">
          <div className="mb-4">
            <Breadcrumb />
          </div>
          
          <div className="w-full">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};